import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API, timeout: 15000 });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("fastority_admin_token", token);
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("fastority_admin_token");
    delete apiClient.defaults.headers.common["Authorization"];
  }
}

const existingToken = localStorage.getItem("fastority_admin_token");
if (existingToken) {
  apiClient.defaults.headers.common["Authorization"] = `Bearer ${existingToken}`;
}

export default apiClient;
